// FourCC quad helper — the C++ multi-character literals ('SIMU', 'WX  ') are big-endian
// packed ASCII; shorter-than-4 names pad with trailing spaces.

export function quad(name: string): number {
  const s = name.padEnd(4, ' ');
  return (
    ((s.charCodeAt(0) << 24) |
      (s.charCodeAt(1) << 16) |
      (s.charCodeAt(2) << 8) |
      s.charCodeAt(3)) >>>
    0
  );
}
